import Reveal from "@/components/Reveal";

export default function SectionHeading({ overline, title, italic, testid }) {
  return (
    <Reveal>
      <p className="font-display text-xs sm:text-sm uppercase tracking-[0.3em] text-saffron" data-testid={testid ? `${testid}-overline` : undefined}>
        {overline}
      </p>
      <h2 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-bone" data-testid={testid}>
        {title} {italic && <em className="text-gold font-light">{italic}</em>}
      </h2>
    </Reveal>
  );
}
